<template>
  <div class="v-full" style="display: flex">
    <div class="left-section">
      <FlexScrollBox>
        <div class="search-controls" slot="controls">
          <div class="search-control-item">
            <CoopePanelCalendarControl />
          </div>
          <div class="search-control-item">
            <CoopePanelTypeControl />
          </div>
          <div class="search-control-item">
            <CoopePanelEntprControl />
          </div>
        </div>
        <CocList slot="main" />
        <div v-show="cocDates.length === 0" class="empty-task-box">
          <Empty :image="emptyTask" :description="$t('home.NoCollaboration')"/>
        </div>
      </FlexScrollBox>
      <div :class="['invite-panel', $i18n.locale === LANGUAGE.CHINESE ? '':'lang-other']" >
        <InviteBtnGroup @inviteMore="inviteMore"  @imCall="collaborate"/>
      </div>
    </div>
    <div
      class="right-section"
      :class="{ 'right-section-active': currentCoc.conferenceId }"
    >
      <template v-if="currentCoc.conferenceId">
        <!-- 上部Panel -->
        <CocDetail />
        <!-- 下部Panel -->
        <CocRecord :channelId="currentCoc.roomId" />
      </template>
      <template v-else>
        <InactiveEmpty />
      </template>
    </div>
    <InviteMoreModal v-model="inviteMoreModalVisible" />
    <CollaborationAppointment @appointSuccess="appointSuccess" ref="colAppointment" v-model="colApptVisible" />
    <AppointmentSuccessful ref="appointSuccess"/>
    <Agreement ref="agreement" />
  </div>
</template>
<script>
import { Empty } from 'ant-design-vue'
import InviteBtnGroup from '@/components/business/ops-btn/InviteBtnGroup.vue'
import {
  CocList,
  CoopePanelCalendarControl,
  CoopePanelTypeControl,
  CoopePanelEntprControl,
  CocDetail,
  CocRecord
} from '@/components/business/coope-panel/index'

import FlexScrollBox from '@/components/behavior/flex-scroll-box/index.vue'
import InactiveEmpty from '@/components/business/empty/InactiveEmpty.vue'
import InviteMoreModal from '@/components/business/invite-more-modal/index.vue'
import { CollaborationAppointment, AppointmentSuccessful } from '@/components/business/collaboration-appointment/index'

import emptyTask from '@/assets/empty-task.svg'

import { mapActions, mapGetters, mapState } from 'vuex'

import { LANGUAGE } from '@/utils/constant'

import Agreement from '@/components/business/Agreement'

export default {
  name: 'CollaborationList',
  components: {
    InviteBtnGroup,
    CoopePanelCalendarControl,
    CoopePanelTypeControl,
    CoopePanelEntprControl,

    CocDetail,
    CocRecord,

    CocList,

    FlexScrollBox,
    InactiveEmpty,
    InviteMoreModal,
    CollaborationAppointment,
    AppointmentSuccessful,
    Empty,

    Agreement
  },
  data() {
    return {
      LANGUAGE: LANGUAGE,
      notfModalVisible: false,
      intfModalVisible: false,
      inviteMoreModalVisible: false,
      colApptVisible: false,
    }
  },
  created() {
    const { conferenceId } = this.$route.query
    if (conferenceId) {
      this.viewCocDetail(conferenceId)
    }
  },
  activated () {
    this.$refs.agreement.getAgreementStatusHandle()
  },
  methods: {
    ...mapActions('coc', ['viewCocDetail']),
    inviteMore() {
      this.inviteMoreModalVisible = true
    },
    collaborate() {
      this.colApptVisible = true
      this.$refs.colAppointment.handleCreate()
    },
    appointSuccess(conferenceId) {
      this.$refs.appointSuccess.init(conferenceId)
    },
    handleOpenNotfModal() {
      this.notfModalVisible = true
    },
    handleOpenIntfModal() {
      this.intfModalVisible = true
    },
  },
  computed: {
    ...mapState('coc', ['cocDates']),
    ...mapGetters('coc', ['currentCoc']),
    emptyTask() {
      return emptyTask
    }
  }
}
</script>
<style lang="less" scoped>
@import url(~@/styles/font.less);
@import url(~@/styles/button.less);
.left-section {
  position: relative;
  flex-shrink: 0;
  height: 100%;
  overflow: auto;
  width: 342px;
  background: #fff;
  box-shadow: 0px -10px 30px 0px rgba(89, 132, 219, 0.1);

  padding-top: 96px;

  .search-input {
    display: block;
    font-size: 16px;
    height: 40px;
    width: 280px;
    margin: 0 auto;
    background-color: #eff3f8;
    box-shadow: 0px 0px 10px 0px rgba(151, 171, 199, 0.15);
    border-radius: 8px;
  }

  .search-controls {
    display: flex;
    flex-direction: row;
    text-align: center;
    font-size: 16px;
    margin-top: 16px;
    margin-bottom: 8px;
    & > .search-control-item {
      flex-shrink: 0;
      flex-basis: 33.333%;
    }
  }

  .invite-panel {
    position: absolute;
    width: 100%;
    left: 0;
    top: 0;
    padding: 24px 32px 32px;
    &::before {
      content: " ";
      left: 0;
      top: 0;
      position: absolute;
      width: 100%;
      height: 100%;
      background: rgba(255, 255, 255, 0.85);
      filter: blur(1px);
    }

    // 翻译添加
    &.lang-other{
      padding: 24px 20px 32px;
      .invite-btn-group ::v-deep .ant-btn{
        font-size: 12px;
      }
    }
    // 翻译添加

    .invite-panel-btn {
      display: block;
      .medium-font(16);
      .primary-btn-mixins();
      width: 231px;
      height: 41px;
      border-radius: 20px;
      margin: 0 auto;
    }
  }
}

.right-section {
  flex-grow: 1;
  height: 100%;
  overflow: auto;
  background: #f7f8fa;
  &.right-section-active {
    padding: 34px 50px 24px 46px;
  }
}

.empty-task-box {
    position: absolute;
    width: 100%;
    top: 50%;
    transform: translateY(-50%);
    ::v-deep .ant-empty-description {
      color: #999b9f;
    }
}
</style>
